<div>
  <h1>404 Not found!</h1>
  <p>Page you are looking for was not found :(</p>
</div>
